import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { QueryClient, QueryClientProvider } from 'react-query';

import { setLanguage } from '@eb/i18n-ebspa';
import { setLanguage as setLanguageEBUI } from '@eb/i18n';

import PageRoutes from './pages/PageRoutes';

const queryClient = new QueryClient({
    defaultConfig: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

export default class ConsumerOneApp extends React.Component {
    constructor(props) {
        super(props);

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        // props.history.replace(props.request.path);

        if (!isEmpty(props)) {
            // eslint-disable-next-line react/prop-types
            setLanguage(props.env.localeInfo.locale);

            // Need to init both EBUI and EBSPA translations or
            // the translations will not be rendered server-side
            setLanguageEBUI(props.env.localeInfo.locale);
        }
    }

    render() {
        return (
            <QueryClientProvider client={queryClient}>
                <PageRoutes {...this.props} />
            </QueryClientProvider>
        );
    }
}
